<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<!-- There is data -->
	<div class="row">
		<div class="col-12">
			<h2>Liste des utilisateurs</h2>
		</div>
	</div>

	<ng-template [ngIf]="hasEmptyList()">
		<!-- No data -->
		<div class="row">
			<div class="col-12">
				<p>Aucun utilisateur enregistré.</p>
				<br><br>
			</div>
		</div>
	</ng-template>

	<ng-template [ngIf]="!hasEmptyList()">
		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prev()" [disabled]="isFirstPage()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="reset()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="next()" [disabled]="isLastPage()" styleClass="p-button-text"></p-button>
		</div>
		<p-table [value]="datas"
			[columns]="columns"
			sortField="username"
			[paginator]="true"
			[rows]="rows"
			[showCurrentPageReport]="true"
			[(first)]="first"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} utilisateur(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-datatable-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.sort"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par identifiant" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="roleChoice" appendTo="body" (onChange)="dt.filter($event.value, 'role', 'equals')" styleClass="p-column-filter" placeholder="Choix du rôle" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-column-filter">
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'firstname', 'contains')" placeholder="Recherche par prénom" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="stateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'global_active', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'company-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'company_name', 'contains')" placeholder="Recherche par société" class="p-column-filter">
					</th>
					<th>&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-usr let-usrs="datas">
				<tr class="table-body-lines">
					<td>
						<a [routerLink]="['/user-detail', usr['_id']]">{{usr["username"]}}</a>
					</td>
					<td>
						<span class="ls-role-user" *ngIf="usr['role']=='U'">Utilisateur</span>
						<span class="ls-role-engineer" *ngIf="usr['role']=='I'">Ingénieur</span>
						<span class="ls-role-admin" *ngIf="usr['role']=='A'">Administrateur</span>
					</td>
					<td>
						<span *ngIf="usr['name'] == ''">-</span>
						<span *ngIf="usr['name'] != ''">{{usr["name"]}}</span>
					</td>
					<td>
						<span *ngIf="usr['firstname'] == ''">-</span>
						<span *ngIf="usr['firstname'] != ''">{{usr["firstname"]}}</span>
					</td>
					<td>
						<span class="ls-state-active" *ngIf="usr['global_active'] == 'A'">Actif</span>
						<span class="ls-state-inactive" *ngIf="usr['global_active'] == 'D'">Désactivé</span>
						<span class="ls-state-inactive" *ngIf="usr['global_active'] == 'SD'">Société désactivée</span>
					</td>
					<td>
						<span *ngIf="usr['company_name'] == '-'">-</span>
						<a [routerLink]="['/company-detail', usr['company_id']]" *ngIf="usr['company_name'] != '-'">{{usr["company_name"]}}</a>
					</td>
					<td>
						<button matTooltip="Editer" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doEdit(usr['_id'], usr['username'], usr['company_name'])"><i class="material-icons md-24 icons">edit</i></button>
						&nbsp;
						<button *ngIf="usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="usr['global_active'] != 'A'" matTooltip="Réinitialiser le mot de passe" mat-raised-button type="button" class="btn btn-info material-item" (click)="doGenerateNewPassword(usr._id, usr.username)"><i class="material-icons md-24 icons">password</i></button>
						&nbsp;
						<button *ngIf="(usr['company_active'] == undefined || usr['company_active']) && usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="usr['active']" matTooltip="Activer l'utilisateur" mat-raised-button type="button" class="btn btn-success material-item" (click)="doActivate(usr._id)"><i class="material-icons md-24 icons">power</i></button>
						&nbsp;
						<button *ngIf="(usr['company_active'] == undefined || usr['company_active']) && usr['username'] != this.cookieService.get(this.constantsModule.cookieUser)" [disabled]="!usr['active']" matTooltip="Désactiver l'utilisateur" mat-raised-button type="button" class="btn btn-danger material-item" (click)="doDeactivate(usr._id)"><i class="material-icons md-24 icons">power_off</i></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</ng-template>
	<br>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Ajouter un utilisateur" mat-raised-button type="button" class="btn btn-primary material-item" (click)="doAdd()"><i class="material-icons md-24 icons">add_box</i> Ajouter ...</button>
			<br><br>
		</div>
	</div>
</div>

